import React, { Component }      from 'react';
import PropTypes from 'prop-types';
import TreeView                             from '../../utils/tree-view';
import urlHandler                           from '../../utils/urlHandler';
import noImageAvailable                     from '../../styles/images/no-image-available.png';
import GoogleMap                            from '../demo/GoogleMap';
import MetaCartaMap                         from '../demo/MetaCartaMap';
import _                                  from 'underscore';

class InterestAreasDetailsControl extends Component {
    constructor(props){
        super(props);

        // Parse/Process entities response to TreeView data struct
        this.getArrayChildren = this.getArrayChildren.bind(this);
        this.getObjectChildren = this.getObjectChildren.bind(this);
        this.getArrayDisplayValue = this.getArrayDisplayValue.bind(this);

        // Callbacks for TreeView
        this.getNodes = this.getNodes.bind(this);
        this.innerNode = this.innerNode.bind(this);
        this.outerNode = this.outerNode.bind(this);
        this.checkLeaf = this.checkLeaf.bind(this);

        this.createTreeData = this.createTreeData.bind(this);

        this.state = {
            data: this.props.data,
            treeData: null,
            error: null
        }

        this.ignoreFields = [
            'id',
            'documentTitle',
            'documentText'
        ]

        this.externalUrlsDisable = window._externalUrlsDisable;
    }

    componentWillMount() {
        this.setState({
            data: this.props.data,
            treeData: this.createTreeData(this.props.data),
            error: null
        })
    }

    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(nextProps.data, this.props.data)) {
            this.setState({
                data: nextProps.data,
                treeData: this.createTreeData(nextProps.data),
                error: null
            })
        }
    }

    getArrayDisplayValue(arr) {
        let val = '';
        if (arr.length > 0) {
            let type = Object.prototype.toString.call(arr[0]);
            if (type != '[object Object]' && type != '[object Array]') {
                val = arr[0];
            } 
        }
        return val;
    }

    getObjectChildren(obj, level) {
        let json = [];
        let nlevel = level + 1;
        Object.keys(obj).map((key, idx) => {
            let type = Object.prototype.toString.call(obj[key]);
            if (type == '[object Object]') {
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    children: this.getObjectChildren(obj[key], nlevel)
                })
            } else if (type == '[object Array]') {
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    value: this.getArrayDisplayValue(obj[key]),
                    children: this.getArrayChildren(obj[key], nlevel)
                })
            } else {
                json.push({
                    name: key,
                    nameDisplay: key,
                    value: obj[key],
                    level: nlevel
                })
            }
        });
        return json;
    }

    getArrayChildren(arr, level, isImage=false) {
        let json = [];
        let nlevel = level + 1;
        Object.keys(arr).map((key, idx) => {
            let type = Object.prototype.toString.call(arr[key]);
            if (type == '[object Object]') {
                var nameDisplay = key;
                var childObj = arr[key];
                json.push({
                    name: key,
                    nameDisplay,
                    level: nlevel,
                    children: this.getObjectChildren(childObj, nlevel)
                })
            } else if (type == '[object Array]') {
                let image = false;
                json.push({
                    name: key,
                    nameDisplay: key,
                    level: nlevel,
                    value: this.getArrayDisplayValue(arr[key]),
                    isImage: image,
                    children: this.getArrayChildren(arr[key], nlevel, image)
                })
            } else if (key !== '0') {
                json.push({
                    name: key,
                    nameDisplay: '',
                    value: arr[key],
                    level: nlevel,
                    isImage
                })
            }
        });
        return json;
    }

    createTreeData(data) {
        var json = [];
        if (data) {
            var response = Object.assign({}, data);
            let level = 0;

            Object.keys(response).map((key, idx) => {
                let type = Object.prototype.toString.call(response[key]);

                if (this.ignoreFields.indexOf(key) == -1) {
                    if (type == '[object Object]') {
                        json.push({
                            name: key,
                            nameDisplay: key,
                            level, 
                            children: this.getObjectChildren(response[key], level)
                        })
                    } else if (type == '[object Array]') {
                        let isImage = false;
                        json.push({
                            name: key,
                            nameDisplay: key,
                            level,
                            isImage,
                            value: this.getArrayDisplayValue(response[key]),
                            children: this.getArrayChildren(response[key], level, isImage)
                        })
                    } else {
                        json.push({
                            name: key,
                            nameDisplay: key,
                            value: response[key],
                            level
                        })    
                    }
                }
            });
        }
        return json;
    }

    nodeImageError(e) {
        e.target.src = noImageAvailable;
    }

	/**
	 * Return the nodes to be displayed in the tree view. This function is initially called
	 * if the root property is not specified in the tree view
	 * @param  {object} parent The parent object linked to the node, or null if the tree needs
	 *                         	to display the root nodes
	 * @return {any}        The list of roots, or a promise object
	 */
	getNodes(parent) {
        let lst = [];
        if (!parent && this.state.treeData) {
            lst = this.state.treeData;
        } else {
            if ('children' in parent) {
                lst = parent.children;
            }
        }
		return lst;
	}

	/**
	 * The title to be displayed, or any other composition of react components
	 * @param  {object} item The object returned by getNodes()
	 * @return {any}         String to be displayed as a title or a react component
	 */
	innerNode(item) {
        return item.nameDisplay;
	}

	/**
	 * React component that will wrap the node link. It will include 2 columns to be displayed
	 * using Twitter Bootstrap to make it responsive
	 * @param  {Component} content 	The react element containing the plus/leaf button and the title
	 * @param  {object} item    	The object linked to the node (returned by getNodes)
	 * @return {Component}         	A new component wrapping the given component
	 */
	outerNode(content, item) {
		return (
			<div key={item.name} className="ia-node-row" style={{fontSize: '13px'}}>
				<div className="ia-node-row-name">
					{content}
				</div>
                <div className="ia-node-row-cols">
                    <div className="ia-node-row-col-1">
                        {item.value}
                        {item.isImage && !this.externalUrlsDisable &&
                            <p>
                                <br/>
                                <img src={item.value} onError={this.nodeImageError}/>
                            </p>
                        }
                    </div>
                </div>
			</div>
		);
	}

	/**
	 * Inform the tree if the node is a leaf, i.e, if the node has no other children
	 * @param  {[type]} item The object linked to the node, created by the <code>getNodes</code> function
	 * @return {boolean}     return true if the node is a leaf
	 */
	checkLeaf(item) {
        if ('children' in item) {
            if (item.children.length === 0) {
                return true;
            }
            return false;
        }
        return true;
    }
    
    render() {    
        return (
            <div>
            {(this.state.data || this.state.error) &&
                <div>
                    {!this.state.error &&
                        <div className="ia-data-wrapper" key="1">
                            <div className="ia-title">{this.state.data.documentTitle}</div>
                            <div className="ia-tree">
                            {this.state.treeData &&
                                <TreeView onGetNodes={this.getNodes}
                                    innerRender={this.innerNode}
                                    checkLeaf={this.checkLeaf}
                                    outerRender={this.outerNode}
                                    root={this.state.treeData}/>
                            }
                            </div>
                            <div className="ia-text">{this.state.data.documentText}</div>
                        </div>
                    }
                </div>
            }
            </div>
        );
    }
}

InterestAreasDetailsControl.propTypes = {
    data: PropTypes.object.isRequired
};

export default InterestAreasDetailsControl;
